// extracted by mini-css-extract-plugin
module.exports = {"container":"FollowSearchBox_container___bIxN","inputArea":"FollowSearchBox_inputArea__lovN_","iconArea":"FollowSearchBox_iconArea__i71oW"};